import React from "react";

export function WizardFormTitle({ musthave, name, description }) {
    const strongStyle = {fontSize: "larger"}
    const preStyle = {whiteSpace: "pre-wrap", fontSize:"larger"}
    return (
        <>
            <strong style={strongStyle}>
                {
                    musthave === "Y" && <span className="text-danger">* </span>
                }
                {
                    `${name} :`
                }
            </strong>
            <pre style={preStyle}>{description}</pre>
        </>

    )
}